import { IApplicationState } from '../../types/redux';

export const selectMlSearchSessionGuid = (state: IApplicationState) => state.analytics.mlSearchSessionGuid;
